import {
  DeiStageActionFieldsInput,
  DeiStageActionFieldsModel,
} from 'generated/graphql';
import { capitalize } from 'lodash';
import { IconType } from '@spotted-zebra-uk/ui-components';

export type DeiFieldValue =
  | 'hasGenderIdentityField'
  | 'hasEthnicityField'
  | 'hasNeurodivergenceIdentifyField'
  | 'hasDisabilityIdentifyField'
  | 'hasFreeSchoolMealsField'
  | 'hasAgeRangeField';

export const deiCheckboxOptions: { label: string; value: DeiFieldValue }[] = [
  {
    label: 'Gender',
    value: 'hasGenderIdentityField',
  },
  {
    label: 'Ethnicity group',
    value: 'hasEthnicityField',
  },
  {
    label: 'Neurodivergent condition',
    value: 'hasNeurodivergenceIdentifyField',
  },
  {
    label: 'Disability or long-term condition',
    value: 'hasDisabilityIdentifyField',
  },
  {
    label: '(UK) Free school meals',
    value: 'hasFreeSchoolMealsField',
  },
  {
    label: 'Age range',
    value: 'hasAgeRangeField',
  },
];

export const getDeiFields = (values: DeiFieldValue[]) => {
  const fields: Record<string, boolean> = {};
  deiCheckboxOptions.forEach((option) => {
    fields[option.value] = values.includes(option.value);
  });

  // Deprecated fields, hardcoded to false - will remove when the BE is updated
  fields.hasDisabilityField = false;
  fields.hasNeurodiversityField = false;
  fields.hasSexualOrientationField = false;
  fields.hasReligiousBeliefsField = false;

  return fields as DeiStageActionFieldsInput;
};

type DeiInputFields = Omit<
  DeiStageActionFieldsModel,
  | '__typename'
  | 'hasSexualOrientationField'
  | 'hasReligiousBeliefsField'
  | 'hasDisabilityField'
  | 'hasNeurodiversityField'
>;
const deiTooltipLabels: Record<keyof DeiInputFields, string> = {
  hasGenderIdentityField: 'gender',
  hasEthnicityField: 'ethnicity group',
  hasNeurodivergenceIdentifyField: 'neurodivergent condition',
  hasDisabilityIdentifyField: 'disability or long-term condition',
  hasAgeRangeField: 'age-range',
  hasFreeSchoolMealsField: '(UK) free school meals',
};

export const getDeiTooltipContent = (fields: DeiStageActionFieldsModel) => {
  const content =
    Object.entries(deiTooltipLabels)
      .filter((elem) => fields[elem[0] as keyof DeiStageActionFieldsModel])
      .map((elem) => deiTooltipLabels[elem[0] as keyof DeiInputFields])
      .join(', ') + '.';

  return capitalize(content);
};

export const deiInitialValues: { deiValues: DeiFieldValue[] } = {
  deiValues: [
    'hasGenderIdentityField',
    'hasEthnicityField',
    'hasDisabilityIdentifyField',
    'hasNeurodivergenceIdentifyField',
    'hasAgeRangeField',
    'hasFreeSchoolMealsField',
  ],
};

export const getPrefilledDeiFields = (
  fields: DeiStageActionFieldsModel,
): DeiFieldValue[] => {
  return Object.entries(fields)
    .filter((field) => field[0] !== '__typename' && field[1])
    .map((field) => field[0]) as DeiFieldValue[];
};

export const removeModalContent = {
  className: 'remove-dei-action-modal',
  type: IconType.WARNING,
  title: 'Are you sure you want to remove this stage action?',
  okButtonChildren: 'Remove',
  message:
    'If the role has already started collecting data, the information gathered will no longer be accessible to clients via the company app. However, internal users can still access the data through the admin app.',
};
